import { render, staticRenderFns } from "./CricleCricle.vue?vue&type=template&id=56c843c4&"
import script from "./CricleCricle.vue?vue&type=script&lang=js&"
export * from "./CricleCricle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports